import React, { Component, Fragment } from 'react';
import './Watch.css';
import * as watches from './watches.json';

export default class Watch extends Component {

    state = {
        data: {},
        screenCount: 1,
        currentSize: "512"
    }

    componentWillMount = () => {
        const script = document.createElement("script");
        script.src = `/watch_files/${this.props.match.params.watch}.js`;
        script.async = true;
        document.body.appendChild(script);
        document.body.style="background: #fff0;"

        let data = watches.slides[watches.slides.findIndex(e => e.name === this.props.match.params.watch)] || false;
        if (data) {
            this.setState({
                data: data,
                screenCount: data.screen_count
            })
        }
    }

    componentDidMount = () => {
        window.addEventListener('message', this.receiveMessage.bind(this));
        setTimeout(this.show, 1000);
        setTimeout(this.shrink,1000);
    }
    
    componentWillUnmount() {
        window.removeEventListener('message', this.receiveMessage.bind(this));
    }

    show() {
        document.getElementById("canvas").style.opacity = "1";
    }

    shrink() {
        document.getElementById("canvas").style.width = "256px";
        document.getElementById("canvas").style.height = "256px";
        document.getElementById("canvas").style.margin = "128px";
        document.getElementById("canvas").style.opacity = "0.5";
    }

    grow() {
        document.getElementById("canvas").style.width = "512px";
        document.getElementById("canvas").style.height = "512px";
        document.getElementById("canvas").style.margin = "0px";
        document.getElementById("canvas").style.opacity = "1";
    }

    toggle = () => {
        if (this.state.currentSize === "256") {
            this.setState({ currentSize: "512" });
            this.grow();
        }
        else {
            this.setState({ currentSize: "256" });
            this.shrink();
        }
    }

    handleClick = () => {
        let { screenCount } = this.state;
        window.var_screen++;
        if (window.var_screen >= screenCount) {
            window.var_screen = 0;
        }
    }

    receiveMessage = (e) => {
        switch (e.data.type) {
            case 'grow':
              this.grow();
              break;
            case 'shrink':
              this.shrink();
              break;
            default: ;
          }
    }

    render() {
        return (
            <Fragment>
                <div>
                    <canvas id="canvas" style={{ width: "512px", height: "512px", margin: "0px", opacity: "0" }} width="512" height="512" onClick={this.handleClick} />
                </div>
            </Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Watch/Watch.js